
import { defineComponent, computed, ref } from 'vue';

// Debounce-Funktion für bessere Performance
function debounce<T extends(...args: any[]) => void>(func: T, wait: number): T {
  let timeout: ReturnType<typeof setTimeout>;
  return ((...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  }) as T;
}

export default defineComponent({
  name: 'ExplorerFilterInput',
  props: {
    columnKey: { type: String, required: true },
    filterValues: { type: Object, required: true },
    min: { type: Number, required: true },
    max: { type: Number, required: true },
  },
  emits: ['update-filter'],
  setup(props, { emit }) {
    const localMin = ref<number>(props.min);
    const localMax = ref<number>(props.max);

    const currentMin = computed(() => props.filterValues[props.columnKey]?.[0] ?? props.min);
    const currentMax = computed(() => props.filterValues[props.columnKey]?.[1] ?? props.max);

    const debouncedUpdateFilter = debounce((min: number, max: number) => {
      emit('update-filter', props.columnKey, [min, max]);
    }, 150);

    const updateMin = (event: Event) => {
      const value = Number((event.target as HTMLInputElement).value);
      localMin.value = value;
      debouncedUpdateFilter(value, currentMax.value);
    };

    const updateMax = (event: Event) => {
      const value = Number((event.target as HTMLInputElement).value);
      localMax.value = value;
      debouncedUpdateFilter(currentMin.value, value);
    };

    return {
      currentMin,
      currentMax,
      updateMin,
      updateMax,
    };
  },
});
